import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { Box, Paper } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import {
	ChemistryElement,
	ChemistryRangeRowDraft,
} from "../../../models/ChemistryRange";
import { useTableData } from "../hooks/useTableData";

type Props = {
	rows: ChemistryRangeRowDraft[];
	elements: ChemistryElement[];
	isLoading: boolean;
	isEditMode: boolean;
	onRowsChange: () => void;
	onGridReady?: (api: GridApi) => void;
};

export const ChemistryRangesTable = ({
	rows,
	elements,
	isLoading,
	isEditMode,
	onRowsChange,
	onGridReady,
}: Props) => {
	const { defaultColDef } = useGridDefinitions({});
	const { columnDefs } = useTableData({ isEditMode, elements });

	return (
		<Paper elevation={2} sx={{ height: "100%", width: "100%" }}>
			<Box
				sx={{
					height: "100%",
					width: "100%",
					"& .chemistry-limit-invalid": { backgroundColor: "#fff3cd" },
				}}
			>
				<AgGridReact<ChemistryRangeRowDraft>
					loading={isLoading}
					rowData={rows}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={34}
					headerHeight={30}
					groupHeaderHeight={26}
					animateRows
					singleClickEdit
					stopEditingWhenCellsLoseFocus
					enterNavigatesVerticallyAfterEdit
					getRowId={(params) => params.data.RowKey}
					loadingOverlayComponent={CenteredLazyLoading}
					onCellValueChanged={(params) => {
						params.api.refreshCells({ force: true, rowNodes: [params.node] });
						onRowsChange();
					}}
					onGridReady={(params) => onGridReady?.(params.api)}
				/>
			</Box>
		</Paper>
	);
};
